import type { ProductLogoSmallProps } from '../types';

/**
 * 小サイズのDevicesロゴアイコン
 */
export function ProductLogoSmallDevices({
  size = 20,
  color = '#1874A1',
  ...props
}: ProductLogoSmallProps) {
  return <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 21 20" fill="none" {...props}>
      <path d="M16.1035 3.5C16.6558 3.5 17.1035 3.94772 17.1035 4.5V5C17.1035 5.27614 16.8797 5.5 16.6035 5.5L2.60352 5.5L2.60352 4.5C2.60352 3.94772 3.05123 3.5 3.60352 3.5L16.1035 3.5Z" fill={color} />
      <path d="M4.60352 5.5L4.60352 12.5H2.60352L2.60352 5.5L4.60352 5.5Z" fill={color} />
      <path d="M11.6035 14.5C11.6035 14.7761 11.3797 15 11.1035 15H3.10352C1.99895 15 1.10352 14.1046 1.10352 13C1.10352 12.7239 1.32737 12.5 1.60352 12.5H11.1035C11.3797 12.5 11.6035 12.7239 11.6035 13V14.5Z" fill={color} />
      <path fillRule="evenodd" clipRule="evenodd" d="M13.6035 6.5C13.0512 6.5 12.6035 6.94772 12.6035 7.5V16C12.6035 16.5523 13.0512 17 13.6035 17H18.1035C18.6558 17 19.1035 16.5523 19.1035 16V7.5C19.1035 6.94772 18.6558 6.5 18.1035 6.5H13.6035ZM14.4368 8C14.2528 8 14.1035 8.14924 14.1035 8.33333V14.1667C14.1035 14.3508 14.2528 14.5 14.4368 14.5H17.2702C17.4543 14.5 17.6035 14.3508 17.6035 14.1667V8.33333C17.6035 8.14924 17.4543 8 17.2702 8H14.4368Z" fill={color} />
    </svg>;
}